// Optional Session Exercises by Phase
// Each exercise is completed individually (not in supersets)
// No videos - only titles and documentation recommendations

export const optionalExercises = [
  // ========== PHASE I ==========
  {
    id: '25dVVL3AT1iLjCeNugNqWA',
    phase: 1,
    exercise: 'Split squats with forward lean',
    documentation: '3 x 6-8/side',
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 0,
  },
  {
    id: 'DJfkzoggRzu4VFuMAnzpaA',
    phase: 1,
    exercise: '1-leg machine leg curl',
    documentation: '3 x 10-12/side',
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 1,
  },
  {
    id: 'XTFAUSowT82HTs7vjdAfUQ',
    phase: 1,
    exercise: '1-leg machine leg extension',
    documentation: '3 x 10-12/side',
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 2,
  },
  {
    id: 'A0t6vTZQS6eACyO.KMkPXQ',
    phase: 1,
    exercise: 'Machine calf raises (seated or standing)',
    documentation: '3 x 10-12 reps',
    hasSide: false,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 3,
  },
  {
    id: 'wu1tKRA1Rr2yVDqQKDN3pQ',
    phase: 1,
    exercise: 'DB farmer\'s carry',
    documentation: '3 x 30-45 seconds',
    hasSide: false,
    hasReps: false,
    hasHoldTime: true,
    hasWeight: true,
    hasNotes: true,
    sequence: 4,
  },
  {
    id: 'H6eml6qQS.WnlmCPhZSBqQ',
    phase: 1,
    exercise: 'Front plank',
    documentation: '3 x 20-30 seconds',
    hasSide: false,
    hasReps: false,
    hasHoldTime: true,
    hasWeight: false,
    hasNotes: true,
    sequence: 5,
  },
  {
    id: '0O.8O.x0TjG.Uyv6e17-Pw',
    phase: 1,
    exercise: 'Upper body exercises',
    documentation: '2-4 exercises',
    hasSide: false,
    hasReps: false,
    hasHoldTime: false,
    hasWeight: false,
    hasNotes: true,
    sequence: 6,
  },
  {
    id: '6q0KOFI3RnWX.FgXoE4w.g',
    phase: 1,
    exercise: 'Cardio (low intensity)',
    documentation: '10-30 minutes',
    hasSide: false,
    hasReps: false,
    hasHoldTime: false,
    hasWeight: false,
    hasNotes: true,
    sequence: 7,
  },

  // ========== PHASE II ==========
  {
    id: 'WQ-FJJ5ESSuBrAzq2eEtlg',
    phase: 2,
    exercise: 'BB front squat OR leg press',
    documentation: '3 x 10-12 reps',
    hasSide: false,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 0,
  },
  {
    id: 'llM8Hy-6RSK.hKU.O1Xp6A',
    phase: 2,
    exercise: '1-leg machine leg curl',
    documentation: '3 x 8-10/side',
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 1,
  },
  {
    id: 'vK9pL2mNQx8rTfYwZjHc3A',
    phase: 2,
    exercise: '1-leg machine leg extension',
    documentation: '3 x 8-10/side',
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 2,
  },
  {
    id: 'bN4qR7sKUy2vXgWmPjLd5B',
    phase: 2,
    exercise: 'Machine calf raises (seated or standing)',
    documentation: '3 x 8-10 reps',
    hasSide: false,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 3,
  },
  {
    id: 'cM5rS8tLVz3wYhXnQkMe6C',
    phase: 2,
    exercise: 'DB suitcase carry',
    documentation: '3 x 20-30 seconds/side',
    hasSide: true,
    hasReps: false,
    hasHoldTime: true,
    hasWeight: true,
    hasNotes: true,
    sequence: 4,
  },
  {
    id: 'dL6sT9uMWa4xZiYoRlNf7D',
    phase: 2,
    exercise: 'Physioball rollout',
    documentation: '3 x 8-10 reps',
    hasSide: false,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: false,
    hasNotes: true,
    sequence: 5,
  },
  {
    id: 'eK7tU0vNXb5yAjZpSmOg8E',
    phase: 2,
    exercise: 'Upper body exercises',
    documentation: '2-4 exercises',
    hasSide: false,
    hasReps: false,
    hasHoldTime: false,
    hasWeight: false,
    hasNotes: true,
    sequence: 6,
  },
  {
    id: 'fJ8uV1wOYc6zBkAqTnPh9F',
    phase: 2,
    exercise: 'Cardio',
    documentation: '10-30 minutes (increase intensity from Phase I)',
    hasSide: false,
    hasReps: false,
    hasHoldTime: false,
    hasWeight: false,
    hasNotes: true,
    sequence: 7,
  },

  // ========== PHASE III ==========
  {
    id: 'gI9vW2xPZd7aClBrUoQi0G',
    phase: 3,
    exercise: 'BB back squat OR leg press',
    documentation: '3 x 8-10 reps',
    hasSide: false,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 0,
  },
  {
    id: 'hH0wX3yQAe8bDmCsVpRj1H',
    phase: 3,
    exercise: 'Deadlift or hip hinge drill',
    documentation: '3 x 8-10 reps',
    hasSide: false,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 1,
  },
  {
    id: 'iG1xY4zRBf9cEnDtWqSk2I',
    phase: 3,
    exercise: 'DB single-leg hip thrust',
    documentation: '3 x 8-10/side',
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 2,
  },
  {
    id: 'jF2yZ5aSCg0dFoEuXrTl3J',
    phase: 3,
    exercise: 'Pallof press',
    documentation: '3 x 8-10/side',
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: false,
    hasNotes: true,
    sequence: 3,
  },
  {
    id: 'kE3zA6bTDh1eGpFvYsUm4K',
    phase: 3,
    exercise: 'Plate straight-leg sit-up',
    documentation: '3 x 8-10 reps',
    hasSide: false,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 4,
  },
  {
    id: 'lD4aB7cUEi2fHqGwZtVn5L',
    phase: 3,
    exercise: 'Straight-leg fire hydrant',
    documentation: '3 x 8-10/side',
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: false,
    hasNotes: true,
    sequence: 5,
  },
  {
    id: 'mC5bC8dVFj3gIrHxAuWo6M',
    phase: 3,
    exercise: 'Upper body exercises',
    documentation: '2-4 exercises',
    hasSide: false,
    hasReps: false,
    hasHoldTime: false,
    hasWeight: false,
    hasNotes: true,
    sequence: 6,
  },
  {
    id: 'nB6cD9eWGk4hJsIyBvXp7N',
    phase: 3,
    exercise: 'Cardio',
    documentation: '10-30 minutes (increase intensity from Phase II)',
    hasSide: false,
    hasReps: false,
    hasHoldTime: false,
    hasWeight: false,
    hasNotes: true,
    sequence: 7,
  },

  // ========== PHASE IV ==========
  {
    id: 'oA7dE0fXHl5iKtJzCwYq8O',
    phase: 4,
    exercise: 'BB back squat OR leg press',
    documentation: '3 x 6-8 reps',
    hasSide: false,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 0,
  },
  {
    id: 'pZ8eF1gYIm6jLuKaDxZr9P',
    phase: 4,
    exercise: 'Deadlift OR cable pull-through',
    documentation: '3 x 6-8 reps',
    hasSide: false,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 1,
  },
  {
    id: 'qY9fG2hZJn7kMvLbEyAs0Q',
    phase: 4,
    exercise: 'DB glute kickback',
    documentation: '3 x 8-10/side',
    hasSide: true,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: true,
    hasNotes: true,
    sequence: 2,
  },
  {
    id: 'rX0gH3iAKo8lNwMcFzBt1R',
    phase: 4,
    exercise: 'DB goblet carry',
    documentation: '3 x 30-45 seconds',
    hasSide: false,
    hasReps: false,
    hasHoldTime: true,
    hasWeight: true,
    hasNotes: true,
    sequence: 3,
  },
  {
    id: 'sW1hI4jBLp9mOxNdGaCu2S',
    phase: 4,
    exercise: 'Roman chair or hanging knee raises',
    documentation: '3 x 8-10 reps',
    hasSide: false,
    hasReps: true,
    hasHoldTime: false,
    hasWeight: false,
    hasNotes: true,
    sequence: 4,
  },
  {
    id: 'tV2iJ5kCMq0nPyOeHbDv3T',
    phase: 4,
    exercise: 'Davies test',
    documentation: '3 x 15 seconds',
    hasSide: false,
    hasReps: false,
    hasHoldTime: true,
    hasWeight: false,
    hasNotes: true,
    sequence: 5,
  },
  {
    id: 'uU3jK6lDNr1oQzPfIcEw4U',
    phase: 4,
    exercise: 'Upper body exercises',
    documentation: '2-4 exercises',
    hasSide: false,
    hasReps: false,
    hasHoldTime: false,
    hasWeight: false,
    hasNotes: true,
    sequence: 6,
  },
  {
    id: 'vT4kL7mEOs2pRaQgJdFx5V',
    phase: 4,
    exercise: 'Cardio',
    documentation: '10-30 minutes (increase intensity from Phase III)',
    hasSide: false,
    hasReps: false,
    hasHoldTime: false,
    hasWeight: false,
    hasNotes: true,
    sequence: 7,
  },
];

/**
 * Get optional exercises for a specific phase
 * @param {number} phaseNum - Phase number (1-4)
 * @returns {Array} Exercises sorted by sequence
 */
export function getOptionalExercises(phaseNum) {
  return optionalExercises
    .filter(ex => ex.phase === phaseNum)
    .sort((a, b) => a.sequence - b.sequence);
}

/**
 * Get optional exercise by ID
 * @param {string} id - Exercise ID
 * @returns {Object|undefined} Exercise object
 */
export function getOptionalExerciseById(id) {
  return optionalExercises.find(ex => ex.id === id);
}